import { InfoCircleOutlined } from "@ant-design/icons";
import { Button, Form, Select, Tooltip } from "antd";
import useGetAgents from "commons/hooks/useGetAgents";
import useGetAllProject from "commons/hooks/useGetAllProject";
import useGetAreaForProject from "commons/hooks/useGetAreaForProject";
import { isEmpty, toInteger } from "lodash";
import CartTips from "pages/CartPrivate/Tips";
import { useTranslation } from "react-i18next";
import { useEffect, useRef } from "react";
import { normalizeParams } from "pages/CartPrivate/helpers";
import { getTokenUser } from "commons/apis/authClient";

const { Option } = Select;

const CartFilter = (props) => {
  const { onFilter, loading, data, length } = props;
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const user = getTokenUser();

  const { data: projects, loading: loadingProjects } = useGetAllProject();
  const { data: agents, loading: loadingAgents } = useGetAgents({
    limit: 1000,
  });
  const {
    data: areas,
    loading: loadingAreas,
    refetch,
  } = useGetAreaForProject();

  const isProjectInitialized = useRef(false);
  const isAreaInitialized = useRef(false);

  const fetchArea = async (projectId) => {
    if (projectId) await refetch(projectId);
  };

  const onFormLayoutChange = (_, values) => {
    if (!values.projectId) {
      form.setFieldsValue({ areaId: undefined });
    }
    fetchArea(values.projectId);
  };

  const submit = (values) => {
    onFilter(normalizeParams(values));
  };

  useEffect(() => {
    if (
      !isProjectInitialized.current &&
      projects?.length > 0 &&
      agents?.length > 0 &&
      !isEmpty(user)
    ) {
      const defaultProject = projects[0]?.project?.id;
      const defaultAgent = user.roleLevel === 4 ? null : agents[0]?.agent?.id;

      form.setFieldsValue({
        projectId: defaultProject,
        agentId: defaultAgent,
      });

      fetchArea(defaultProject);

      isProjectInitialized.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projects, agents, user]);

  useEffect(() => {
    if (!isAreaInitialized.current && areas?.length > 0) {
      const defaultArea = areas[0]?.area?.id;
      const currentValues = form.getFieldsValue();

      const finalValues = {
        ...currentValues,
        areaId: defaultArea,
      };

      form.setFieldsValue(finalValues);
      onFilter(finalValues);
      isAreaInitialized.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [areas]);

  return (
    <div className="wrapper-header">
      {toInteger(length) > 0 && (
        <Tooltip
          title={<CartTips data={data} />}
          placement="bottomLeft"
          overlayClassName="tips-tooltip"
        >
          <span className="label-statistic">
            <InfoCircleOutlined className="info-statistic" />
            <span>{t("winners.detail")}</span>
          </span>
        </Tooltip>
      )}
      <Form
        form={form}
        className="cart-filter"
        onValuesChange={onFormLayoutChange}
        onFinish={submit}
      >
        <Form.Item name="agentId">
          <Select
            placeholder={t("winners.selectAgent")}
            allowClear
            loading={loadingAgents}
          >
            {user?.roleLevel === 4 && (
              <Option value={null}>{t("winners.cartGeneral")}</Option>
            )}
            <Option value={user?.roleLevel === 4 ? -1 : ""}>
              {t("winners.cartPublic")}
            </Option>
            {agents.map(({ agent }, index) => (
              <Option key={index} value={agent?.id}>
                {agent?.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="projectId">
          <Select
            placeholder={t("winners.selectProject")}
            allowClear
            loading={loadingProjects}
          >
            {projects.map(({ project }, index) => (
              <Option key={index} value={project?.id}>
                {project?.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item name="areaId">
          <Select
            placeholder={t("winners.selectArea")}
            allowClear
            loading={loadingAreas}
          >
            {areas.map(({ area }, index) => (
              <Option key={index} value={area?.id}>
                {area?.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="filter-button"
          loading={loading}
        >
          {t("winners.apply")}
        </Button>
      </Form>
    </div>
  );
};

export default CartFilter;
